import type {DetailedHTMLProps, InputHTMLAttributes, ReactElement} from 'react'

import {copilotFeatureFlags} from '../utils/copilot-feature-flags'
import {AgentAutocomplete} from './autocomplete/AgentAutocomplete'
import {UnifiedAutocomplete} from './autocomplete/UnifiedAutocomplete'

export function Autocomplete({
  children,
}: {
  children: ReactElement<DetailedHTMLProps<InputHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>>
}) {
  return copilotFeatureFlags.chatAutocomplete ? (
    <UnifiedAutocomplete>{children}</UnifiedAutocomplete>
  ) : (
    <AgentAutocomplete>{children}</AgentAutocomplete>
  )
}

try{ Autocomplete.displayName ||= 'Autocomplete' } catch {}